import {
    getVideoLinksAPI,
    getNewsAPI,
    getDashboardAnalyticsAPI,
    getTopPerformersAPI
} from "./api"

export function getVideoLinks(data) {
    return new Promise((resolve, reject) => {
        getVideoLinksAPI(data).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getNews(data) {
    return new Promise((resolve, reject) => {
        getNewsAPI(data).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getDashboardAnalytics() {
    return new Promise((resolve, reject) => {
        getDashboardAnalyticsAPI().then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getTopPerformers() {
    return new Promise((resolve, reject) => {
        getTopPerformersAPI().then((res) => resolve(res)).catch(err => reject(err))
    })
}